import { Component, ElementRef, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ExpenseFormSortComponent } from '../expense-form-sort/expense-form-sort.component';
import { ExpenseFormItemComponent } from '../expense-form-item/expense-form-item.component';

@Component({
  selector: 'app-expense-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, NgbCollapseModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './expense-form.component.html',
  styleUrl: './expense-form.component.scss'
})
export class ExpenseFormComponent {
  TripData = [{ TripID: 1, TripName: 'Trip 1' }, { TripID: 2, TripName: 'Trip 2' },]
  isDisabled: boolean = false;
  Advance = false;
  filter = {
    activeid: 1
  }
  Expense = {
    TravelTypeID: null,
    AdvanceExpenseID: null as any,
    TripName: null, // only for outstation
    ExpenseCategoryID: null,
    KMs: null,
    ExpenseDate: null,
    Merchant: null,
    Description: null,
    ExpenseAmount: null,
    Attachment: null,
  }

  AdvanceExpense = {
    TripName: null,
    FromDate: null,
    ToDate: null,
    AdvanceAmount: null,
    Description: null,
    Items: [{
      ExpenseCategoryID: null,
      Description: null,
      Merchant: null,
      Rate: null,
      KMs: null,
      ExpenseAmount: null,
    }],
    ItemsNew: [{
      ExpenseCategory: "Expance Category 1",
      Description: "Description 1",
      Merchant: "Merchant 1",
      Rate: 20,
      KMs: 10,
      ExpenseAmount: 200,
      ProjectedAmount: 180,
      Date : "30 JUL 2024",
      Attachment : ""
    },{
      ExpenseCategory: "Expance Category 2",
      Description: "Description 2",
      Merchant: "Merchant 2",
      Rate: 40,
      KMs: 6,
      ExpenseAmount: 240,
      ProjectedAmount: 250,
      Date : "31 JUL 2024",
      Attachment : ""
    }]
  }

  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
  ) {
  }

  addItem() {
    // this.AdvanceExpense.Items.push({
    //   ExpenseCategoryID: null,
    //   Description: null,
    //   Merchant: null,
    //   Rate: null,
    //   KMs: null,
    //   ExpenseAmount: null,
    // });
    const modalRef = this.modalService.open(ExpenseFormItemComponent,{ size: 'lg', backdrop: 'static', });
    modalRef.componentInstance.TravelType = 'Local';
    modalRef.result.then(
      (result: any) => {
        if (result != undefined && result != null) {
          this.TripData.push({
            TripID: this.TripData.length + 1,
            TripName: result.TripName
          })
          this.Expense.AdvanceExpenseID = this.TripData.length;
        }
      },
      () => { }
    );
  }

  DeleteItem(index: number) {
    //this.AdvanceExpense.Items.splice(index, 1);
    this.AdvanceExpense.ItemsNew.splice(index, 1);
  }

  activeTab(id: number) {
    this.filter.activeid = id;
  }

  @ViewChild('scrollOne') scrollOne!: ElementRef;
  @ViewChild('scrollTwo') scrollTwo!: ElementRef;

  updateScrollOne() {
    const scrollOne = this.scrollOne.nativeElement as HTMLElement;
    const scrollTwo = this.scrollTwo.nativeElement as HTMLElement;
    // do logic and set
    scrollTwo.scrollLeft = scrollOne.scrollLeft;
  }

  updateScrolltwo() {
    const scrollOne = this.scrollOne.nativeElement as HTMLElement;
    const scrollTwo = this.scrollTwo.nativeElement as HTMLElement;
    // do logic and set
    scrollOne.scrollLeft = scrollTwo.scrollLeft;
  }

  AddTrip() {
    const modalRef = this.modalService.open(ExpenseFormSortComponent);
    modalRef.result.then(
      (result: any) => {
        if (result != undefined && result != null) {
          this.TripData.push({
            TripID: this.TripData.length + 1,
            TripName: result.TripName
          })
          this.Expense.AdvanceExpenseID = this.TripData.length;
        }
      },
      () => { }
    );
  }
}
